
import Preaudits from '../../views/preaudits/Preaudits.vue'
import Preaudit from '../../views/preaudits/Preaudit.vue'
import PreauditSchedule from '../../views/preaudits/PreauditSchedule.vue'
import {roleSystemRoute} from './route_utilities'

export const preaudits = {
	path: 'preaudits',
	name: 'Preaudits',
	component: Preaudits,
	meta: {
		title: "on_planlamalar",
		domain:"preaudits",
    accessroles:["admin","brand","auditor","planner"],
	},
}

export const preaudit = {
      path: 'preaudit/:id',
      name: 'Preaudit',
      component: Preaudit,
      redirect: { name: 'PreauditSchedule' },
      meta: {
          title: "on_planlama",
          preloader:true,
          domain:"preaudits",
          accessroles:["admin","brand","auditor","planner"],
        },
        children:[
        {
          path: 'schedule',  
          name: 'PreauditSchedule',
          component: PreauditSchedule,
          meta: {
              title: "takvim",
              preloader:true,
              domain:"preaudits"
            },
          }, 
        ]
      }


 